import { WidgetConfig } from 'grosella/types'
import React, { h, createContext, ComponentChildren } from 'preact'

export const WidgetConfigContext = createContext<WidgetConfig>(
    {} as WidgetConfig
)

interface Props {
    children: ComponentChildren
    config: WidgetConfig
    element?: HTMLElement
}

export const WidgetConfigProvider: React.FunctionalComponent<Props> = ({
    children,
    config,
}: Props) => {
    return (
        <WidgetConfigContext.Provider value={config}>
            {children}
        </WidgetConfigContext.Provider>
    )
}
